import React, { Component } from 'react';
import axios from 'axios'
import { pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, Feed } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

function ShowPaymentsUI(props) {

    const updateUI = props.payment
        ? <Feed.Event>
            <Feed.Content>
                <Feed.Summary>
                    {toCurrency(props.payment.amount)}
                </Feed.Summary>
                <Feed.Meta>
                    <Feed.Like>
                        {props.payment.paymentdate}
                    </Feed.Like>
                </Feed.Meta>
                <Feed.Meta>
                    <Feed.Like>
                        {props.payment.description}
                    </Feed.Like>
                </Feed.Meta>
            </Feed.Content>
        </Feed.Event>
        : ''

    return (
        <div>{updateUI}</div>
    )
}

class AddPaymentToProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            payments: []
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }


    sendProjectPayment = () => {
        console.log("++++++++:sendProjectPayment");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (this.props.projectId == '') {
            alert("No projectId Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.paymentAmount == '') {
            alert("No paymentAmount Entered")
        } else if (this.state.balance == '') {
            alert("No balance Entered")
        } else if (this.state.dateNum == '') {
            alert("No payment date Entered")
        } else if (this.state.description == '') {
            alert("No description entered")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'addProjectPayment', {
                apiKey: "PrintB@da7",
                projectId: this.props.projectId,
                enteredBy: this.props.user.email,
                paymentAmount: this.state.paymentAmount,
                balance: this.state.balance,
                paymentDate: this.state.dateNum,
                description: this.state.description,
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    getProjectPayments = () => {
        console.log("++++++++:getProjectPayments");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (this.props.projectId == '') {
            alert("No projectId sent")
        } else {
            console.log("getting payments data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'getPaymentsOnProject', {
                apiKey: "PdddrisdfantB@asdf",
                projectId: this.props.projectId,
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. got payments");

                        this.setState({
                            payments: response.data.payments
                        })
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const sendPaymentButton = this.state.description != ''
            ? <Button >ADD PAYMENT</Button>
            : ''

        const showPaymentsList = this.state.payments.map((payment) =>

            <ShowPaymentsUI payment={payment} />
        );

        const showPaymentsUi = this.state.payments.length > 0
            ? <div>
                <Divider horizontal>{'PROJECT PAYMENTS'}</Divider>
                {showPaymentsList}
            </div>
            : ''


        const enterPaymentUI =
            <div>
                {showPaymentsUi}
                <Button onClick={this.getProjectPayments} > Show Payments </Button>

                <Divider horizontal>{' ADD PAYMENT TO PROJECT'}</Divider>

                <Form size='large' onSubmit={this.sendProjectPayment}>
                    <Segment stacked>
                        <h3>ENTER PAYMENT DETAILS </h3>

                        <label>Enter PAYMENT DATE AMOUNT:{toCurrency(this.state.paymentAmount)}</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Payment Amount'
                            type='text'
                            name="paymentAmount"
                            value={this.state.paymentAmount}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Balance (if a certain amount remains unpaid){toCurrency(this.state.balance)}</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Balance'
                            type='text'
                            name="balance"
                            value={this.state.balance}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Description / Notes</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Balance'
                            type='text'
                            name="description"
                            value={this.state.description}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Date Payment was made</label>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>

                        {sendPaymentButton}
                    </Segment>
                </Form>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {enterPaymentUI}

        </div>);
    }
}

export default AddPaymentToProject;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/AddPaymentToProject.js